import GameState from 'slotworks/model/game-state';
import BonusResult from 'slotworks/model/gameplay/records/results/bonus-result';
import { Exit } from 'slotworks/state-machine/data/exit';
import Decision from 'slotworks/state-machine/decisions/decision';

export default class IsTreasureBonusEnterCheck extends Decision {
    public evaluate() {
        let triggered = false;
        const currentRecord: any = GameState.getCurrentGame().getCurrentRecord();

        if (currentRecord.getResultsOfType(BonusResult)[0]?.id === 'BONUS') {
            triggered = true;
        }

        return triggered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./src/desicions/treasure-bonus-enter-check.ts